// @core/api/endpoints/workflow/capture_test_case.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CaptureTestCaseRequest,
  TestCaseResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Capture execution as test case
 * Records all node inputs/outputs from a completed execution and creates a test case with those as mock data.
 */
export async function CaptureTestCase(
  execution_id: string,
  data: CaptureTestCaseRequest,
  options?: RequestOptions
): Promise<TestCaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id/capture`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<TestCaseResponse>(requestPath, data, requestOptions);
}
